import { MouseEvent, useCallback } from 'react';
import { StyledSelectListItem } from './SelectListItem.styled';
import { SelectListItemProps } from './types';

export const SelectListItem = <TValue extends string | number>(
  props: SelectListItemProps<TValue>,
) => {
  const { disabled, index, option, selected, onSelect } = props;

  /**
   * Handle clicking on the option element
   */
  const handleClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      if (disabled) {
        return;
      }

      onSelect(event, index, !selected);
    },
    [disabled, index, selected, onSelect],
  );

  return (
    <StyledSelectListItem $disabled={disabled} $selected={selected} onClick={handleClick}>
      {option.content}
    </StyledSelectListItem>
  );
};
